<template lang="html">
  <div>
    <Navbar />
    <div class="content-i">
      <div class="content-box">
        <div class="row">
          <div v-if="showEinvoiceModal">
            <RalpEInvoiceForm :eInvoiceModal="modalVariant" :userDetails="userDetails" :showModal="showEinvoiceModal"></RalpEInvoiceForm>
          </div>
          <ResponseInfo class="mb-3" v-if="getResponseInfo.responseName == 'homepage'" />
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-8 col-sm-12">
            <div class="element-wrapper">
              <h6 class="element-header">{{ t('homeTitle', 'homeTitle')}}</h6>
              <div class="element-box">
                <div class="element-info">
                  <div class="row align-items-center">
                    <div class="col-sm-8">
                      <div class="element-info-with-icon">
                        <div class="element-info-icon text-center">
                          <img v-if="getUserDetails.profilePicture" :src="getUserDetails.profilePicture + '?' + this.cacheValue" class="user-pic" alt="profile picture" style="max-height: 50px;">
                          <div v-else class="os-icon os-icon-user-male-circle"></div>
                        </div>
                        <div class="element-info-text">
                          <h5 class="element-inner-header welcomeUsername">{{ t('welcomeKey', 'welcomeKey')}} <span v-if="getUserDetails.name">{{getUserDetails.name}}</span> <span v-else-if="getUserDetails.username">{{getUserDetails.username}}</span> <span v-else>{{getUserDetails.email}}</span>,</h5>
                          <div class="element-inner-desc">
<!--                            EIPP-679 added a conditionally rendering the last login if a user has one-->
                            <template v-if="hasLastLogin">
                              {{ t('lastLoginKey', 'lastLoginKey')}} {{getUserDetails.last_login | formatDate}}
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <p v-html="formatWelcomeMessage(welcomeMessage)"></p>
                    <p v-if="getUserLevel >= 2.00 && showEditButton"><a href="javascript:;" v-on:click="enableEditor()">{{ t('editMessageKey', 'editMessageKey')}}</a></p>
                  </div>
                </div>
                <div class="row" v-if="showEditor">
                  <div class="col-12 mb-2">
                    <select v-model="welcomeMsgLang" @change="getWelcomeMsgTranslation()" class="form-control">
                      <option v-for="lang in getLanguageList" :value="lang.code">{{ lang.code }}</option>
                    </select>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <vue-editor v-model="welcomeMessage" :editorToolbar="customToolbar"></vue-editor><br />
                    <button class="btn btn-primary" v-on:click="updateWelcomeMessage()">{{ t('updateMessageKey', 'updateMessageKey')}}</button>
                    <button class="btn btn-secondary" @click="restoreWelcomeMessage()">{{ t('cancelUpdateMessageKey', 'cancelUpdateMessageKey')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-sm-12">
            <div class="element-wrapper">
              <h6 class="element-header">{{ t('quickLinksTitle', 'quickLinksTitle')}}</h6>
              <loading
                  id="widget-loading-spinner"
                  class="align-items-center quicklink-loader "
                  :color="'#047bf8'"
                  :loader="'spinner'"
                  :active="isQuickLinksLoading"
                  :transition="'fade'"
                  :is-full-page="false">
              </loading>
              <div v-if="!isQuickLinksLoading">
                <div v-if="quickLinks" class="row px-1 py-0">
                  <div class="col-lg-6 col-md-6 col-sm-6 mb-3" v-for="link in quickLinks" :key="link.item_name">
                    <UserQuickLink :link="link"></UserQuickLink>
                  </div>
                </div>
                <div v-else class="row">
                  <div class="col-12 text-center">
                    {{ t('noQuickLinksFound', 'noQuickLinksFound') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <template v-if="isClientConfigSettingsLoaded">
            <div class="col-sm-12 col-md-6 col-lg-3" v-for="idx in parseInt(clientConfigSettings.max_dashboard_widgets)" :key="idx">
              <AddWidget :index="idx"></AddWidget>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="showEinvoiceModal" class="modal-backdrop show"></div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Helper_Components/Footer'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { VueEditor } from "vue2-editor";
import ResponseInfo from '@/components/ResponseInfo.vue'
import RalpEInvoiceForm from '@/components/EInvoicingForm/RalpEInvoiceForm.vue'
import Loading from 'vue-loading-overlay'
import { clientShortName } from '@/helpers/clientShortName.js'

// Widgets
import AddWidget from '@/components/Widgets/AddWidget.vue'

// QuickLinks
import UserQuickLink from '@/components/Users/UserQuickLink.vue'

export default {
  name: 'portal',
  data() {
    return {
      eInvoiceModal: false,
      showEinvoiceModal: false,
      showEditor: false,
      showEditButton: true,
      customToolbar: [
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: "" },{ align: "center" },{ align: "right" },{ align: "justify" }],
          [{ header: 1 }, { header: 2 }],
          ["link", "formula"],
      ],
      cacheValue: new Date().getTime(),
      userDetails: null,
      welcomeMsgLang: localStorage.getItem('currentTranslation'),
      welcomeMessage: '',
      oldMessage: '',
      // NS-9909 Client can change number of widgets in "Site Settings", VS
      isClientConfigSettingsLoaded: false,
      clientConfigSettings: {
        max_dashboard_widgets: 2,
      },
      quickLinks: null,
      isQuickLinksLoading: false
    }
  },
  components:{
    Navbar,
    VueEditor,
    ResponseInfo,
    RalpEInvoiceForm,
    AddWidget,
    UserQuickLink,
    Loading,
    Footer
  },
  methods: {
    updateWelcomeMessage() {
      this.showEditButton = true
      this.showEditor = false
      this.$store.dispatch('updateWelcomeMessage', {
        message: this.welcomeMessage,
        lang: this.welcomeMsgLang
      }).then(response => {
        this.welcomeMsgLang = localStorage.getItem('currentTranslation')
        this.welcomeMessage = this.getWelcomeMsgTranslation()
      })
    },
    restoreWelcomeMessage() {
      this.showEditor = false
      this.showEditButton = true
      this.welcomeMsgLang = localStorage.getItem('currentTranslation')
      this.welcomeMessage = this.getWelcomeMsgTranslation()
    },
    formatWelcomeMessage(welcomeMessage) {
      if(welcomeMessage) {
        return welcomeMessage.replace(/\n/g , "<br>")
      }
    },
    update() {
      this.cacheValue = new Date().getTime()
    },
    getWelcomeMsgTranslation() {
      this.$store.dispatch('getWelcomeMessage', localStorage.getItem('currentTranslation')).then(response => {
        this.welcomeMessage = response
        this.oldMessage = response
      })
    },
    enableEditor() {
      this.showEditor = !this.showEditor
      this.showEditButton = false
      this.welcomeMessage = this.getWelcomeMsgTranslation()
    },
    getUserQuickLinks() {
      this.isQuickLinksLoading = true
      this.$store.dispatch('homepageStore/getUserQuickLinks').then(() => {
        this.quickLinks = this.$store.getters['homepageStore/getQuickLinks']
        this.isQuickLinksLoading = false
      })
    },
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet','getWelcomeMessage', 'getUserLevel', 'getResponseInfo', 'getLanguageList', 'getEinvoicingStatus']),
      clientName() {
        let clientName = clientShortName()
        return clientName
      },
      //EIPP-679 added a condition when the last login date is null the last login block still shows up.
      hasLastLogin() {
        return this.getUserDetails.last_login !== null;
      }
  },
  created() {
    let showEinv = this.getEinvoicingStatus
    if((this.clientName == 'ralp' || this.clientName == 'ralptest') && showEinv) {
      this.$store.dispatch('homepageStore/displayEInvoice', this.getUserDetails).then(response => {
        this.showEinvoiceModal = response.showInvoiceModal
        this.userDetails = response.userDetails

        if (response.displayForm) {
          this.modalVariant = true
        } else {
          this.modalVariant = false
        }
      })
    }

    if (this.getUserDetails.level == '3.00') {
      this.hasAccess = true;
    }

    // NS-9909 Load client config to know how many widgets we need to display, VS
    this.$store.dispatch('getClientConfigurationSettings')
        .then(() => {
          this.clientConfigSettings = this.$store.getters.getClientConfigurationSettings;
          this.isClientConfigSettingsLoaded = true;
        })

    // NS-10691 Get available user quicklinks, PW
    this.getUserQuickLinks()
  },
  mounted() {
     this.welcomeMessage = this.getWelcomeMsgTranslation()
  },
  filters:{
    formatDate: function(date) {
      return moment(date).fromNow();
    }
  }
}
</script>

<style lang="css" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
body{
  padding: 0px;
}
.welcomeUsername span{
  color: #047bf8;
}
.widget-box {
  min-height: 300px;
  position: relative;
}
.center-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.quicklink-loader {
  height: 75% !important;
}
</style>
